import {
  browserTracingIntegration,
  consoleLoggingIntegration,
  init,
  tanstackRouterBrowserTracingIntegration,
} from '@sentry/react'
import type { AnyRouter } from '@tanstack/react-router'

export function initSentry(dsn: string | undefined, router: AnyRouter) {
  if (!dsn) return

  init({
    dsn,
    enableLogs: true,
    environment: import.meta.env.VITE_DEPLOY_ENV,
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    ignoreErrors: ['Transition was skipped', 'Transition was aborted'],
    integrations: [
      browserTracingIntegration(),
      tanstackRouterBrowserTracingIntegration(router),
      consoleLoggingIntegration({
        levels: ['log', 'warn', 'error', 'info'],
      }),
    ],
    tracePropagationTargets: [import.meta.env.VITE_API_URL],
  })
}
